import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

@Component({
  selector: 'app-components-specialist-rejecttask',
  templateUrl: './reject-task.component.html'
})
export class RejectTaskComponent {
  @Input() rejectionCtrl: UntypedFormGroup;
  @Output() saved: EventEmitter<any> = new EventEmitter<any>();
  @Output() canceled: EventEmitter<any> = new EventEmitter<any>();

  cancel(): void {
    this.canceled.emit();
  }

  save(): void {
    if (!this.rejectionCtrl.valid) {
      this.rejectionCtrl.markAllAsTouched();
      return;
    }

    this.saved.emit();
  }
}
